module.exports = "/packs/media/images/oldercouple_camping_resize-2aed4053cf75e108971f3ce46721a8b1.jpg";